var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHelpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.252 17.3309C11.2456 14.1507 13.8218 11.5693 17.002 11.5693H26.9861C30.1572 11.5693 32.7297 14.1367 32.7361 17.3078L32.748 23.2575C32.7544 26.4376 30.1781 29.019 26.998 29.019H22.7514L18.3815 32.1894C17.4962 32.8317 16.2712 32.1075 16.4072 31.0222L16.6595 29.0083C13.6533 28.8255 11.27 26.3327 11.2639 23.2806L11.252 17.3309ZM17.002 13.0693C14.6514 13.0693 12.7472 14.9773 12.752 17.3279L12.7639 23.2776C12.7686 25.6214 14.67 27.519 17.0139 27.519H18.3579L17.9672 30.6368L22.2646 27.519H26.998C29.3485 27.519 31.2527 25.6111 31.248 23.2605L31.2361 17.3108C31.2314 14.9669 29.3299 13.0693 26.9861 13.0693H17.002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6137 18.3607C19.6137 17.0265 20.6895 15.9507 22.0237 15.9507C23.358 15.9507 24.4337 17.0265 24.4337 18.3607C24.4337 19.4136 23.7415 19.9693 23.2884 20.2789C23.094 20.4132 22.9687 20.5189 22.8875 20.6278C22.8201 20.7182 22.7737 20.8228 22.7737 20.9907V21.2007C22.7737 21.6149 22.4379 21.9507 22.0237 21.9507C21.6095 21.9507 21.2737 21.6149 21.2737 21.2007V20.9907C21.2737 19.9139 21.9824 19.3578 22.4376 19.0435L22.4408 19.0413C22.6259 18.9149 22.7471 18.8117 22.8248 18.7067C22.8899 18.6189 22.9337 18.5184 22.9337 18.3607C22.9337 17.8549 22.5295 17.4507 22.0237 17.4507C21.518 17.4507 21.1137 17.8549 21.1137 18.3607C21.1137 18.7749 20.778 19.1107 20.3637 19.1107C19.9495 19.1107 19.6137 18.7749 19.6137 18.3607Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2694 23.5908C21.2694 23.1766 21.6052 22.8408 22.0194 22.8408H22.0284C22.4426 22.8408 22.7784 23.1766 22.7784 23.5908C22.7784 24.005 22.4426 24.3408 22.0284 24.3408H22.0194C21.6052 24.3408 21.2694 24.005 21.2694 23.5908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHelpLight);
export default __webpack_public_path__ + "static/media/btn_help_light.9e3a81d0e47cb8509e4a9df478ed0651.svg";
export { ForwardRef as ReactComponent };